import React from 'react';
import injectSheet from 'react-jss';
import {
  Dialog,
  RaisedButton,
  FlatButton,
  TextField, IconButton,
} from 'material-ui';
import R from 'ramda';
import pluralize from 'pluralize';
import { connect } from 'react-redux';
import {
  updateGroup,
} from '../../../stores/profile/company/profile-actions';

const propTypes = {
  groupToManage: React.PropTypes.object,
  open: React.PropTypes.bool,
  type: React.PropTypes.string,
  dataArray: React.PropTypes.array,
  classes: React.PropTypes.object,
  savingGroup: React.PropTypes.bool,
  deleteGroup: React.PropTypes.func,
  updateGroup: React.PropTypes.func,
  onRequestClose: React.PropTypes.func,
};

class ManageGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = props.groupToManage || {};
  }

  componentWillReceiveProps(nextProps) {
    this.state = {
      ...this.state,
      ...(nextProps.groupToManage || {}),
    };
  }
  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== React.PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }

  deleteGroup = () => this.props.deleteGroup(this.state);

  updateGroup = () => this.props.updateGroup(this.state);

  render() {
    const {
      open,
      type,
      onRequestClose,
      dataArray = [],
      classes,
      savingGroup,
    } = this.props;

    const {
      items = [],
      groupName,
      groupId,
    } = this.state;
    const allSelectedIds = R.pluck('id', items);
    const label = type === 'location' ? 'Locations' : 'Products';
    return (
      <Dialog
        open={open}
        autoDetectWindowHeight
        autoScrollBodyContent
        onRequestClose={onRequestClose}
        title={
          <div className="flex-center">
            {!groupId ? 'Create Group' : 'Manage Group'}
            <IconButton
              iconClassName="tc-icon-delete2"
              iconStyle={{ color: '#ff4081' }}
              style={{ padding: '0', width: '36px', height: '24px', marginLeft: '16px' }}
              tooltip="Delete Group"
              tooltipPosition="top-right"
              onTouchTap={this.deleteGroup}
            />
          </div>
        }
        actions={[
          <FlatButton
            label="cancel"
            onTouchTap={onRequestClose}
            primary
          />,
          <FlatButton
            label={savingGroup ? 'saving' : 'confirm'}
            disabled={savingGroup || !groupName || !items.length}
            onTouchTap={this.updateGroup}
            secondary
          />
        ]}
      >
        <small style={{ marginTop: '12px', display: 'block' }}>
          Groups are similar to folders and are used to allow you to organize your {label}.
        </small>
        <TextField
          floatingLabelText="Group Name"
          id="groupName"
          value={groupName || ''}
          onChange={(_, val) => this.setState({ groupName: val })}
        />
        {
          Boolean(items.length) && <div style={{ marginTop: '16px', fontWeight: 'bold' }}>{items.length} {pluralize(label, items.length)} included in this group:</div>
        }
        <div className={classes.selected}>
          {
            items.map((obj, index) => {
              return (
                <div
                  key={obj.id}
                  className={`${classes.listContainer} flex-tc-sb`}
                >
                  {obj.name}
                  <RaisedButton
                    label="Remove"
                    labelColor="#ff4081"
                    onTouchTap={() => this.setState({ items: R.remove(index, 1, items) })}
                  />
                </div>
              );
            })
          }
        </div>
        <div style={{ marginBottom: '16px', fontWeight: 'bold' }}>{items.length ? `Additional ${label}` : label} you can add to this group:</div>
        {
          dataArray.map(obj => {
            const selected = allSelectedIds.indexOf(obj.id) > -1;
            if (selected) return;
            return (
              <div
                key={obj.id}
                className={`${classes.listContainer} flex-tc-sb`}
              >
                {obj.name}
                <RaisedButton
                  label={selected ? 'Remove' : 'Add'}
                  secondary
                  disabled={selected}
                  onTouchTap={() => this.setState({ items: R.append(obj, items) })}
                />
              </div>
            );
          })
        }
      </Dialog>
    );
  }
}

const styles = {
  listContainer: {
    marginBottom: '8px',
  },
  selected: {
    maxHeight: '200px',
    overflowY: 'scroll',
    borderBottom: '1px solid #e0e0e0',
    margin: '16px 0 ',
    padding: '0 1px',
  },
};

ManageGroup.propTypes = propTypes;

const mapStateToProps = null;

export default connect(mapStateToProps, {
  updateGroup,
})(injectSheet(styles)(ManageGroup));



// WEBPACK FOOTER //
// ./src/app/components/profile/location-or-product-list/manage-group.jsx